




























































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import ShuttleBox from '@/components/shuttleBox/shuttleOldBox.vue';
import logger from 'vuex/types/logger';
import { deepClone } from '@/util/deepClone';
import ShuttleChildernBox from '@/components/shuttleBox/shuttleChildernBox.vue';
@Component({
  components: { ShuttleBox, ShuttleChildernBox },
})
export default class BranchCondition extends Vue {
  judgeOptions: any = [
    {
      value: '=',
      label: '等于',
    },
    {
      value: '<',
      label: '小于',
    },
    {
      value: '<=',
      label: '小于等于',
    },
    {
      value: '>',
      label: '大于',
    },
    {
      value: '>=',
      label: '大于等于',
    },
    {
      value: '!=',
      label: '不等于',
    },
  ];
  private tableData: any = [
    {
      date: '2016-05-03',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-04',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-01',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-08',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-06',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
    {
      date: '2016-05-07',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄',
    },
  ];

  multipleSelection: any = [];

  private visible = false;
  private count = 1; // 可用条件个数

  private branchGroup: any = []; // 条件组
  private branchGroupId = 1; // 新建条件组时添加的每一项

  startAuthOrgMember: any = [];
  choseSponsorIndex: any;
  nodeConfig: any;
  nodeConfigIndex: any;
  conditionGroups: any;
  branchGroupIndex: any;
  formBranchIndex: any;

  get deptTree() {
    return this.$store.state.user.deptTree;
  }

  choseStaff(index: any, index2: any) {
    // 打开只有部门下级人员的审批弹出框
    this.branchGroupIndex = index;
    this.formBranchIndex = index2;

    const data = this.branchGroup[index].formBranch[index2].value || '';
    const arr: any = [];
    data.split(',').forEach((item: any) => {
      const obj: any = {
        objId: item,
        objName: this.idToName(item, 'staff'),
        type: 'staff',
      };
      arr.push(obj);
    });

    console.log(data);
    const shuttleChildrenBox = 'shuttleChildrenBox';
    const shuttleChildrenBoxComponent = this.$refs[shuttleChildrenBox];
    (shuttleChildrenBoxComponent as any).showDialog(arr);
  }

  checkChildrenNodeData(data: any) {
    console.log(data);
    const arr: any = [];
    data.forEach((item: any) => {
      arr.push(item.objId);
    });

    this.branchGroup[this.branchGroupIndex].formBranch[this.formBranchIndex].value = arr.toString();
  }

  idToName(id: any, type: any) {
    const arr: any = [];
    let name: any = '';
    if (type === 'staff') {
      this.deptTree.forEach((dept: any) => {
        dept.staffList.forEach((staff: any) => {
          if (id === staff.staffId) {
            name = staff.staffName;
          }
        });
      });
    }
    if (type === 'dept') {
      this.deptTree.forEach((dept: any) => {
        if (id === dept.id) {
          name = dept.name;
        }
      });
    }
    return name;
  }

  handleSelectionChange(arg: any, index: any) {
    this.multipleSelection = arg[0];
    console.log(arg[0]);
    this.branchGroup[index].checkForm = arg[0];
  }

  private async showDrawer(nodeConfig: any, form: any, index: any) {
    this.branchGroup = [];
    console.log(nodeConfig);
    this.nodeConfig = nodeConfig;
    this.nodeConfigIndex = index;
    this.visible = true;

    const arr: any = [];
    form.formData &&
      form.formData.forEach((item: any) => {
        const value: any = '';
        // if(nodeConfig.formControlAuth) {
        //   for(let key  in nodeConfig.formControlAuth){
        //     if (key === item.form.id) {
        //       value = nodeConfig.formControlAuth[key];
        //     }
        //   }
        // }
        // arr.push({
        //   id: item.form.id,
        //   formField: item.form.label,
        //   handle: value,
        // });
        arr.push(item);
      });
    this.tableData = arr;
    console.log(this.tableData);

    if (this.nodeConfig.conditionNodes[this.nodeConfigIndex - 1].conditionGroups) {
      const conditionGroups: any = this.nodeConfig.conditionNodes[this.nodeConfigIndex - 1].conditionGroups;
      conditionGroups.forEach((itemGroups: any, indexGroups: any) => {
        const obj: any = {
          launch: false,
          startAuthOrgMember: [],
          formBranch: deepClone(this.tableData),
          checkForm: [],
        };
        // 判断条件筛选
        obj.formBranch.forEach((item: any, index: any) => {
          if (item.type === 'RadioInput') {
            obj.formBranch[index].conditionWay = '=';
          }
          if (item.type === 'ContactsInput') {
            obj.formBranch[index].conditionWay = '=';
          }
        });
        this.branchGroup.push(obj);
        itemGroups.conditions.forEach((item: any, index: any) => {
          if (item.type === 'sponsor') {
            item.property.staff.length > 0 &&
              item.property.staff.forEach((staff: any) => {
                const obj: any = {
                  objId: staff,
                  objName: this.idToName(staff, 'staff'),
                  type: 'staff',
                };
                this.branchGroup[indexGroups].startAuthOrgMember.push(obj);
                this.branchGroup[indexGroups].launch = true;
              });
            item.property.dept.length > 0 &&
              item.property.dept.forEach((dept: any) => {
                const obj: any = {
                  objId: dept,
                  objName: this.idToName(dept, 'dept'),
                  type: 'department',
                };
                this.branchGroup[indexGroups].startAuthOrgMember.push(obj);
                this.branchGroup[indexGroups].launch = true;
              });
          }
          if (item.type === 'control') {
            const forArr: any = [];
            this.branchGroup[indexGroups].formBranch.forEach((form: any, formIndex: any) => {
              if (form.form.id === item.property.controlId) {
                this.branchGroup[indexGroups].formBranch[formIndex].conditionWay = item.property.conditionWay;
                this.branchGroup[indexGroups].formBranch[formIndex].value = item.property.value;
                forArr.push(form);
              }
            });
            this.toggleSelection(forArr, indexGroups);
          }
        });
      });
      console.log(this.branchGroup);
    }
  }

  toggleSelection(rows: any, index: any) {
    this.$nextTick(() => {
      console.log(rows);
      if (rows) {
        rows.forEach((row: any) => {
          console.log(this.$refs.multipleTable);
          (this.$refs.multipleTable as any)[index].toggleRowSelection(row);
        });
      } else {
        (this.$refs.multipleTable as any)[index].clearSelection();
      }
    });
  }

  private branchData: any = {
    priority: '', // 优先级
    sponsorText: '',
  };

  private options = [
    {
      label: '优先级1',
      value: 'youxianji1',
    },
    {
      label: '优先级2',
      value: 'youxianji2',
    },
  ];

  choseSponsor(index: any) {
    this.choseSponsorIndex = index;
    const shuttleBox = 'shuttleBox';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    console.log(this.branchGroup[index].startAuthOrgMember);
    (shuttleBoxComponent as any).showDialog(this.branchGroup[index].startAuthOrgMember);
  }

  checkNodeData(data: any) {
    this.branchGroup[this.choseSponsorIndex].startAuthOrgMember = data;
  }

  handleClose() {
    this.visible = false;
  }

  /**
   * @desc 添加 或 字位置的判断
   */
  addHuo() {
    if (this.branchGroup.length > 1) {
      for (let i = 0; i < this.branchGroup.length - 1; i++) {
        const element = document.getElementsByClassName('branch_group')[i];
        element.classList.add('add_huo');
      }
    }
  }

  /**
   * @desc 点击添加条件组
   */
  addBranchGroup() {
    const obj: any = {
      launch: false,
      startAuthOrgMember: [],
      formBranch: deepClone(this.tableData),
      checkForm: [],
    };

    // 判断条件筛选
    obj.formBranch.forEach((item: any, index: any) => {
      if (item.type === 'RadioInput') {
        obj.formBranch[index].conditionWay = '=';
      }
    });
    this.branchGroup.push(obj);
    // this.branchGroup.push(this.branchGroupId);
    // this.addHuo();
    // this.$forceUpdate();
    // this.branchGroupId++;
  }

  /**
   * @desc 点击删除图标删除条件组
   */
  removeBranchGroup(item: any) {
    const index = this.branchGroup.indexOf(item);
    for (let i = 0; i < this.branchGroup.length; i++) {
      const element = document.getElementsByClassName('branch_group')[i];
      element.classList.remove('add_huo');
    }
    this.branchGroup.splice(index, 1);
    this.addHuo();
    this.$forceUpdate();
  }

  /**
   * @desc 点击添加条件组中的 添加条件
   */
  addLaunch(index: any) {
    console.log(index);
    this.branchGroup[index].launch = true;
    // if (this.count <= 0) {
    //   alert('已没有可用条件');
    // } else {
    //   this.count--;
    // }
  }

  /**
   * @desc 点击删除按钮删除条件
   */
  removeLaunch(index: any) {
    this.branchGroup[index].launch = false;
  }

  saveData() {
    const conditionGroups: any = [];

    this.branchGroup.forEach((item: any) => {
      const conditions: any = [];
      const obj: any = {
        type: 'sponsor',
        property: {
          staff: [],
          dept: [],
          space: [],
        },
      };

      item.startAuthOrgMember.forEach((member: any) => {
        if (member.type === 'department') {
          obj.property.dept.push(member.objId);
        }
        if (member.type === 'staff') {
          obj.property.staff.push(member.objId);
        }
      });

      if (obj.property.space.length === 0 && obj.property.dept.length === 0 && obj.property.staff.length === 0) {
        delete obj.property;
      } else {
        if (obj.property.staff.length === 0) {
          delete obj.property.staff;
        }
        if (obj.property.dept.length === 0) {
          delete obj.property.dept;
        }
        if (obj.property.space.length === 0) {
          delete obj.property.space;
        }
        conditions.push(obj);
      }

      // let formArr: any = [];
      console.log(item.checkForm);
      item.checkForm.forEach((form: any) => {
        const formObj = {
          type: 'control',
          property: {
            controlId: form.form.id,
            value: form.value,
            conditionWay: form.conditionWay,
          },
        };
        conditions.push(formObj);
      });
      // conditionGroups.conditions = conditions;
      conditionGroups.push({
        conditions: conditions,
      });
    });
    console.log(conditionGroups);

    this.nodeConfig.conditionNodes[this.nodeConfigIndex - 1].conditionGroups = conditionGroups;
    this.$emit('setData', this.nodeConfig);
    this.visible = false;
  }
}
